/**
 * Explicit transport spelling; stored/domain enum values remain unchanged.
 * Keyed by property name, so a key must not be shared by properties whose
 * domain values differ (unit and pool `status` already travel lowercase).
 */
const resourceEnums: Record<string, Record<string, string>> = {
  sourceType: { BOOKING: 'booking', SESSION: 'session' },
  unitTrackingMode: { BULK: 'bulk', TRACKED: 'tracked' },
  action: { PICK_UP: 'pickUp', RETURN: 'return', NO_SHOW: 'noShow' },
};

function mapEnums(value: unknown, encode: boolean, strict: boolean): unknown {
  if (Array.isArray(value)) return value.map((item) => mapEnums(item, encode, strict));
  if (!value || typeof value !== 'object') return value;
  return Object.fromEntries(
    Object.entries(value).map(([key, item]) => {
      const values = resourceEnums[key];
      if (values && typeof item === 'string') {
        if (encode) return [key, values[item] ?? item];
        const entry = Object.entries(values).find(([, wire]) => wire === item);
        if (entry) return [key, entry[0]];
        if (strict) throw new Error(`Invalid ${key}; expected ${Object.values(values).join(', ')}`);
      }
      return [key, mapEnums(item, encode, strict)];
    }),
  );
}

export const encodeResourceWire = (value: unknown): unknown => mapEnums(value, true, false);
export const decodeResourceWire = (value: unknown, strict = true): unknown => mapEnums(value, false, strict);
